import de from './de.js'
import en from './en.js'
import es from './es.js'
import fr from './fr.js'
import it from './it.js'
import pt from './pt.js'
import ru from './ru.js'
import tr from './tr.js'
import ua from './ua.js'

export default {
    de,
    en,
    es,
    fr,
    it,
    pt,
    ru,
    tr,
    ua
}